var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6097_6429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1886 9.13782L11.9998 1.45032L1.80168 9.13782C1.59085 9.33237 1.46408 9.60138 1.44824 9.88782V21.6272C1.44898 21.8701 1.54582 22.1029 1.71761 22.2747C1.88939 22.4465 2.12217 22.5433 2.36512 22.5441H8.47949V17.625C8.47949 16.6926 8.84989 15.7984 9.50919 15.1391C10.1685 14.4798 11.0627 14.1094 11.9951 14.1094C12.9275 14.1094 13.8217 14.4798 14.481 15.1391C15.1403 15.7984 15.5107 16.6926 15.5107 17.625V22.5469H21.6242C21.8672 22.5461 22.1001 22.4493 22.272 22.2776C22.444 22.1058 22.541 21.873 22.542 21.63V9.88782C22.5258 9.60148 22.3991 9.33261 22.1886 9.13782Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6097_6429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.0b2e66f4370f6c42a0817ac64eb2f77c.svg";
export { ForwardRef as ReactComponent };